import script from "./FoundryContractContent.vue?vue&type=script&setup=true&lang=js"
export * from "./FoundryContractContent.vue?vue&type=script&setup=true&lang=js"

import "./FoundryContractContent.vue?vue&type=style&index=0&id=f1771be0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1771be0"]])

export default __exports__